import { createContext, useState } from "react";

export type Menu = {
  id: string;
  url: string;
  label: string;
  active?: boolean;
  hidden: boolean;
};

export const initialState = {
  global: {},
  menu: [
    {
      id: "mojipodaci",
      url: "/upravljanje-podacima/moji-podaci",
      label: "Moji podaci (My information)",
      hidden: true,
    },
    {
      id: "ostalioperateri",
      url: "/upravljanje-podacima/ostali-operateri",
      label: "Ostali operateri (Other operators)",
      hidden: true,
    },
    {
      id: "certifikat",
      url: "/upravljanje-podacima/certifikat",
      label: "Certifikat (Certificate)",
      hidden: true,
    },
    {
      id: "dostavapodataka",
      url: "/upravljanje-podacima/dostava-podataka",
      label: "Dostava podataka (Data delivery)",
      hidden: true,
    },
    {
      id: "oslobodjenje",
      url: "/upravljanje-podacima/oslobodenje",
      label: "Oslobođenje (Exemption)",
      hidden: true,
    },
    {
      id: "pristup",
      url: "/upravljanje-podacima/upute",
      label: "Pristup servisu (Service access)",
      hidden: true,
    },
    {
      id: "brisanjeoperatera",
      url: "/upravljanje-podacima/brisanje-operatera",
      label: "Brisanje operatera (Deletion of operator)",
      hidden: true,
    },
  ],
};

export const Context = createContext(null as any);

export const ContextProvider = ({ initialProps, children }: any) => {
  const [contextData, setContextData] = useState({ ...initialProps });

  return (
    <Context.Provider value={[contextData, setContextData]}>
      {children}
    </Context.Provider>
  );
};
